export default "__VITE_ASSET__914acc17__"